import type { AnalyticsPlatform } from "../../../api.ts";

/** 凭据 / 广告列表：无「全部」，每 Tab 一平台 */
export const ANALYTICS_PLATFORM_SEGMENTS: ReadonlyArray<{
  readonly value: AnalyticsPlatform;
  readonly label: string;
}> = [
  { value: "facebook", label: "Facebook" },
  { value: "tiktok", label: "TikTok" },
  { value: "google", label: "Google" },
  { value: "sharechat", label: "ShareChat" },
];

/** 转化 / 访问等数据列表：含「全部」 */
export const ANALYTICS_PLATFORM_FILTER_SEGMENTS: ReadonlyArray<{
  readonly value: AnalyticsPlatform | "all";
  readonly label: string;
}> = [{ value: "all", label: "全部" }, ...ANALYTICS_PLATFORM_SEGMENTS];
